// extracted by css-extract-rspack-plugin
export default {"footer":"footer-aKIg31","confirmRow":"confirmRow-tSUXnz"};